<template>
    <div class="check-date">
        <el-date-picker
            v-model="value"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            value-format="timestamp"
            end-placeholder="结束日期"
            @change="doSearch"
            :clearable="false"
            >
        </el-date-picker>
        <span class="ml40">成交量：{{totalNum}}t</span>
        <span class="ml40">成交额：{{totalPrice}}</span>
        <div class="mt4">
            <ListItem :isHead="true" :data="headOption"></ListItem>
            <div class="data-wrap">
                <el-scrollbar style="height: 100%;">
                    <ListItem
                        :isCheck="true"
                        v-for="(item, index) in list" 
                        :key="index" 
                        :data="item">
                    </ListItem>
                </el-scrollbar>
            </div>
        </div>
    </div>
</template>

<script>
import ListItem from '@/components/ListItem.vue';
import { getStorage } from '@/utils/index';
export default {
    name: 'checkDate',
    data: function() {
        return {
            value: '',
            list: [],
            headOption: {
                name: '商家',
                num: '成交量',
                price: '成交额',
            },
            totalList: []
        }
    },
    components: {
        ListItem
    },
    props: [],
    methods: {
        matchDate(date) {
            const time = new Date(date);
            const start = this.value[0];
            const end = this.value[1];
            return time >= start && time <= end;
        },
        doSearch() {
            const list = [];
            this.totalList.forEach(item => {
                let totalNum = 0;
                let totalPrice = 0;
                item.list.forEach(ware => {
                    if(this.matchDate(ware.date)) {
                        totalNum += ware.amount;
                        totalPrice += ware.amount * ware.singlePrice;
                    }
                });
                totalNum > 0 && list.push({
                    name: item.name,
                    totalNum,
                    totalPrice
                });
            });
            this.list = list;
        }
    },
    computed: {
        totalNum() {
            let res = 0;
            this.totalList.forEach(item => {
                item.list.forEach(ware => {
                    if(this.matchDate(ware.date)) {
                        res += ware.amount;
                    }
                })
            });
            res = res.toFixed(4);
            return res;
        },
        totalPrice() {
            let res = 0;
            this.totalList.forEach(item => {
                item.list.forEach(ware => {
                    if(this.matchDate(ware.date)) {
                        res += (ware.amount * ware.singlePrice);
                    }
                })
            });
            res = res.toFixed(4);
            return res;
        }
    },
    mounted() {
        getStorage().then(res => {
            this.totalList = res.slice(1);
            const date = new Date();
            const item = new Date(`${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`).getTime();
            this.value = [item, item];
            this.doSearch();
        });
    }

}
</script>

<style>
.check-date {
    width: 100%;
}
.data-wrap {
    height: 400px;
    overflow: auto;
}
.el-scrollbar__wrap {
    overflow-x: hidden!important;
}
.el-range-separator {
    width: 25px!important;
}
.mt4 {
    margin-top: 20px;
}
</style>